import { useMenuStore } from '../zustand/store/useMenuStore';
import useModalStore from '../zustand/store/useModalStore';

// 권한 없음 안내 문구. 서버 403 공통 처리(AxiosCORS)의 기본 문구와 같게 쓴다
export const NO_PERMISSION_MESSAGE = '이 기능을 사용할 권한이 없습니다.\n담당자에게 문의해주세요.';

/**
 * 화면 진입 때 받은 메뉴 권한(롤 권한 + 개인 권한)으로 버튼 동작을 막는다.
 * 버튼은 숨기지 않고 그대로 두며, 권한이 없으면 누를 때 안내창만 띄운다(서버도 같은 기준으로 403).
 *
 * flag: 'UPYN'(등록 · 수정) · 'DLYN'(삭제)
 *   등록 · 수정은 한 칸(REYN = UPYN)이라 등록도 UPYN 으로 본다. 예전 롤별메뉴 화면이 남긴 REYN Y · UPYN N 행이 있어도 등록이 열리지 않는다(서버 MenuPermissionGuard 와 같은 기준)
 *   const { withPermission } = useMenuPermission();
 *   <button onClick={withPermission('UPYN', save)}>저장</button>
 */
const useMenuPermission = () => {
    const permissions = useMenuStore(state => state.permissions);
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const can = (flag) => permissions?.[flag] === 'Y';

    const withPermission = (flag, action) => (...args) => {
        if (!can(flag)) {
            showNotiModal(NO_PERMISSION_MESSAGE);
            return undefined;
        }
        return action(...args);
    };

    return { can, withPermission };
};

export default useMenuPermission;
